import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import {
  API_URL,
  getMediaUrl
} from "../config/api";

import sanitizeRichHtml from
  "../utils/sanitizeRichHtml";

  import {
  getSafeExternalUrl
} from "../utils/safeUrl";

function Footer() {

  const [footer, setFooter] =
    useState(null);

  const [mostRead, setMostRead] =
    useState([]);


  const fetchFooter = async () => {

    try {

      const response =
        await axios.get(
          `${API_URL}/api/footer`
        );

      setFooter(response.data);

    }

    catch (error) {

      console.error(
        "Error loading footer:",
        error
      );

    }

  };

  const fetchMostRead = async () => {

    try {

      const response =
        await axios.get(
          `${API_URL}/api/most-read`
        );

      setMostRead(
        response.data || []
      );

    }

    catch (error) {

      console.error(
        "Error loading most read:",
        error
      );

    }

  };


  useEffect(() => {

    fetchFooter();
    fetchMostRead();


    const handleFooterUpdated = () => {
      fetchFooter();
      fetchMostRead();
    };


    window.addEventListener(
      "footerUpdated",
      handleFooterUpdated
    );


    return () => {

      window.removeEventListener(
        "footerUpdated",
        handleFooterUpdated
      );

    };

  }, []);


  if (!footer) {
    return null;
  }


  const quickLinks =
    [...(footer.quickLinks || [])]
      .filter(
        link => link.enabled
      )
      .sort(
        (a, b) =>
          a.order - b.order
      );


  const socialLinks = [

    {
      name: "Facebook",
      url: footer.socialLinks?.facebook
    },

    {
      name: "Instagram",
      url: footer.socialLinks?.instagram
    },

    {
      name: "Threads",
      url: footer.socialLinks?.threads
    },

    {
      name: "X",
      url: footer.socialLinks?.x
    },

    {
      name: "YouTube",
      url: footer.socialLinks?.youtube
    },

    {
      name: "LinkedIn",
      url: footer.socialLinks?.linkedin
    },

    {
      name: "Telegram",
      url: footer.socialLinks?.telegram
    }

  ]
  .map(
    social => ({
      ...social,
      url:
        getSafeExternalUrl(
          social.url
        )
    })
  )
  .filter(
    social => social.url
  );

  const safeWebsiteUrl =
  getSafeExternalUrl(
    footer.contact?.website
  );

  const getSubcategoryLabel = (subcategory) =>
  subcategory === "Science"
    ? "Science & Technology"
    : subcategory;

  const getMostReadLink = (item) => {

    if (!item) {
      return "/";
    }

    if (item.contentType === "post") {
      return `/post/${item._id}`;
    }

    if (item.contentType === "publication") {

      if (item.pdf) {
        return getMediaUrl(item.pdf);
      }

      if (item.type === "book") {
        return "/publications/books";
      }

      if (item.type === "newspaper") {
        return "/publications/newspapers";
      }

      if (item.type === "magazine") {
        return "/publications/magazines";
      }

    }

    return "/";
  };


  return (

    <footer className="site-footer">

      <div className="footer-container">


        {/* =================================
            BRAND
        ================================= */}

        <div className="footer-brand">

          {footer.logo && (

            <img
              src={getMediaUrl(footer.logo)}
              alt={
                footer.publicationName
              }
              className="footer-logo"
            />

          )}

          {footer.tagline && (

            <p className="footer-tagline">
              {footer.tagline}
            </p>

          )}


          {footer.description && (

            <div
              className="footer-description"
              dangerouslySetInnerHTML={{
  __html:
    sanitizeRichHtml(
      footer.description
    )
}}
            />

          )}

        </div>


        {/* =================================
            QUICK LINKS
        ================================= */}

        <div className="footer-links">

          <h3>
            Quick Links
          </h3>


          {quickLinks.map(
            link => (

              <Link
                key={link.path}
                to={link.path}
              >
                {link.label}
              </Link>

            )
          )}

        </div>

        {/* =================================
            MOST READ
        ================================= */}

        <div className="footer-most-read">

          <h3>
            Most Read
          </h3>

          {mostRead.length === 0 ? (

            <p className="footer-most-read-empty">
              No reading data yet.
            </p>

          ) : (

            <div className="footer-most-read-list">

              {mostRead.map((item) => {

                const link =
                  getMostReadLink(item);

                const isPublication =
                  item.contentType === "publication";

                return (

                  <div
                    key={`${item.contentType}-${item._id}`}
                    className="footer-most-read-item"
                  >

                    <span className="footer-most-read-dot"></span>

                    <div className="footer-most-read-content">

                      {isPublication ? (

                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.title}
                        </a>

                      ) : (

                        <Link to={link}>
                          {item.title}
                        </Link>

                      )}

                      <small>

                        {item.contentType === "publication"
                          ? (
                              item.type === "book"
                                ? "Book"
                                : item.type === "newspaper"
                                  ? "Newspaper"
                                  : "Magazine"
                            )
                          : (
                              item.subcategory
                                ? `${item.category} / ${getSubcategoryLabel(
                                    item.subcategory
                                  )}`
                                : item.category
                            )
                        }

                      </small>

                    </div>

                  </div>

                );

              })}

            </div>

          )}

        </div>


        {/* =================================
            CONTACT
        ================================= */}

        <div className="footer-info">

          <h3>
            Contact
          </h3>


          {footer.contact?.address && (

            <p>
              {footer.contact.address}
            </p>

          )}


          {footer.contact?.email && (

            <p>

              <a
                href={`mailto:${footer.contact.email}`}
              >
                {footer.contact.email}
              </a>

            </p>

          )}


          {footer.contact?.phone && (

            <p>

              <a
                href={`tel:${footer.contact.phone}`}
              >
                {footer.contact.phone}
              </a>

            </p>

          )}


          {safeWebsiteUrl && (

            <p>

              <a
                href={safeWebsiteUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Website
              </a>

            </p>

          )}

        </div>


        {/* =================================
            SOCIAL
        ================================= */}

        {socialLinks.length > 0 && (

          <div className="footer-social">

            <h3>
              Follow Us
            </h3>


            <div className="footer-social-links">

              {socialLinks.map(
                social => (

                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {social.name}
                  </a>

                )
              )}

            </div>

          </div>

        )}

      </div>


      {/* =================================
          COPYRIGHT
      ================================= */}

      <div className="footer-bottom">

        <p>
          © {new Date().getFullYear()} {footer.publicationName}. All rights reserved.
        </p>

      </div>

    </footer>

  );

}

export default Footer;